const texts = {
  title: 'Pool roster',
  description: "Changes apply to every AC's Pool Queue on next load.",
  addTitle: 'Add coaches to the pool',
  addDescription: 'Search and select any number of coaches, then add them in one action.',
  addPlaceholder: 'Search coaches by name',
  addToPool: 'Add to pool',
  addCountToPool: 'Add {count} to pool',
  rosterCount: '{count} coaches in the pool',
  tableColumns: {
    coach: 'Coach',
    activeClients: 'Active clients',
    createdAt: 'Date added',
    addedBy: 'Added by',
    actions: 'Actions',
  },
  unknownUser: '—',
  removeFromPool: 'Remove from pool',
  countLoading: '…',
  countUnavailable: '—',
};

export default texts;
